export function convertTo24Hour(time12h) {
    if (!time12h) return "";
  
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");
  
    if (hours === "12") {
      hours = "00";
    }
  
    if (modifier?.toUpperCase() === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
  
    return `${hours.toString().padStart(2, "0")}:${minutes}`;
  }
  